<script lang="ts">
  import {sortDirection} from '../../stores/filter-and-sort';
  import IconButton from '../icon-button/IconButton.svelte';

  let topPathElement: SVGPathElement | null = null;
  let bottomPathElement: SVGPathElement | null = null;

  // Update icon paths depending on the sort direction
  $: {
    if (topPathElement && bottomPathElement) {
      if ($sortDirection === 'desc') {
        topPathElement.setAttribute(
          'd',
          'M 18.996,5 V 3 c 0,-0.552 -0.447,-1 -1,-1 H 1.0040001 V 6 H 17.996 c 0.553,0 1,-0.447 1,-1 z'
        );
        bottomPathElement.setAttribute(
          'd',
          'm 6.996,17 v -2 c 0,-0.552 -0.447,-1 -1,-1 H 1.0040001 v 4 H 5.996 c 0.553,0 1,-0.447 1,-1 z'
        );
      } else {
        topPathElement.setAttribute(
          'd',
          'M 6.996,4.996 v -2 c 0,-0.552 -0.447,-1 -1,-1 H 1.004 v 4 h 4.992 c 0.553,0 1,-0.447 1,-1 z'
        );
        bottomPathElement.setAttribute(
          'd',
          'M 18.996,16.996 v -2 c 0,-0.552 -0.447,-1 -1,-1 H 1.004 v 4 h 16.992 c 0.553,0 1,-0.447 1,-1 z'
        );
      }
    }
  }
</script>

<style lang="postcss">
  /* Transition only works in chromium browsers at the moment */
  path {
    transition: all 200ms ease-in;
  }
</style>

<IconButton
  class={$$props.class}
  on:click={() => sortDirection.toggle()}
  title="Invert sorting"
  aria-label="Invert sorting">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path
      fill="currentColor"
      d="M 18.996,5 V 3 c 0,-0.552 -0.447,-1 -1,-1 H 1.0040001 V 6 H 17.996 c 0.553,0 1,-0.447 1,-1 z"
      bind:this={topPathElement} />
    <path
      fill="currentColor"
      d="M 12.996,10.996 v -2 c 0,-0.552 -0.447,-1 -1,-1 H 1.004 v 4 h 10.992 c 0.553,0 1,-0.447 1,-1 z" />
    <path
      fill="currentColor"
      d="M 6.996,17 v -2 c 0,-0.552 -0.447,-1 -1,-1 H 1.0040001 v 4 H 5.996 c 0.553,0 1,-0.447 1,-1 z"
      bind:this={bottomPathElement} />
  </svg>
</IconButton>
